import { uiConstant } from "../constants/uiConstant";

// Set Initial State
const initialState = {
  loading: false,
  requestPending: 0,
  lazyLoading: false
};

export default function (state = initialState, action) {
  switch (action.type) {

    //overall loader
    case uiConstant.LOADING_TRUE:
      return {
        ...state,
        requestPending: state.requestPending + 1,
        loading: true
      };
    case uiConstant.LOADING_FALSE:
      const requestPending = state.requestPending - 1 > 0 ? state.requestPending - 1 : 0;
      return {
        ...state,
        requestPending: requestPending,
        loading: !(requestPending === 0)
      };

    case uiConstant.LAZY_LOADING_TRUE:
      return {
        ...state,
        lazyLoading: true,
      };
    case uiConstant.LAZY_LOADING_FALSE:
      return {
        ...state,
        lazyLoading: false,
      };
    default:
      return state;
  }
}
